import { Link } from 'react-router-dom';
import { verifiedProperties } from '@/mocks/properties';
import { propertyRoute } from '@/mocks/propertyRoutes';

type Props = {
  text: string;
  refs?: string[];
  onPropertyNavigate?: () => void;
};

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function propertyForName(name: string) {
  return verifiedProperties.find((property) => property.name === name);
}

export default function GuestGuideAnswer({ text, refs = [], onPropertyNavigate }: Props) {
  const linkedProperties = refs
    .map((name) => propertyForName(name))
    .filter((property): property is NonNullable<typeof property> => Boolean(property));

  const names = linkedProperties.map((property) => property.name).sort((a, b) => b.length - a.length);
  const paragraphs = text.split(/\n{2,}/).filter(Boolean);
  const splitLinkedText = (value: string) =>
    names.length > 0 ? value.split(new RegExp(`(${names.map(escapeRegExp).join('|')})`, 'g')) : [value];

  return (
    <>
      <div className="space-y-3">
        {paragraphs.map((paragraph, paragraphIndex) => (
          <p key={`${paragraph}-${paragraphIndex}`}>
            {splitLinkedText(paragraph).map((part, index) => {
              const property = propertyForName(part);
              if (!property) return <span key={`${part}-${paragraphIndex}-${index}`}>{part}</span>;

              return (
                <Link
                  key={`${property.id}-${paragraphIndex}-${index}`}
                  to={propertyRoute(property.id)}
                  onClick={onPropertyNavigate}
                  className="font-medium underline decoration-accent-500/40 underline-offset-4 hover:text-accent-700 transition-colors"
                >
                  {property.name}
                </Link>
              );
            })}
          </p>
        ))}
      </div>

      {linkedProperties.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {linkedProperties.map((property) => (
            <Link
              key={property.id}
              to={propertyRoute(property.id)}
              onClick={onPropertyNavigate}
              className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-wider px-2.5 py-1.5 rounded-lg bg-[#EFE4D6] text-accent-900 hover:bg-[#E9DCCB] transition-colors"
            >
              View {property.name}
              <i className="ri-arrow-right-up-line text-[11px]" />
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
